import { render } from "./PaymentMethodsTab.vue?vue&type=template&id=ca0874e2&scoped=true"
import script from "./PaymentMethodsTab.vue?vue&type=script&lang=js"
export * from "./PaymentMethodsTab.vue?vue&type=script&lang=js"

import "./PaymentMethodsTab.vue?vue&type=style&index=0&id=ca0874e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca0874e2"]])

export default __exports__